import React, { Dispatch, SetStateAction } from 'react';
import { Button, Typography, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { dialogContent, paperProps } from './SuccessModal.sx';
import { closeBtn } from '../Filter/Filter.sx';
import CloseIcon from '../Icons/CloseIcon';
import DialogContent from '@mui/material/DialogContent';
import SuccessIcon from '../Icons/SuccessIcon';
import ErrorIcon from 'app/components/Icons/ErrorIcon';

import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  successText: string;
  unsuccess?: boolean;
  sign?: any;
  closeAsan?: any;
  path?: string;
  closeWithoutRedirect?: any;
  templates?: boolean;
  closeParentModal?: any;
}

const SuccessModal = (props: Props) => {
  const {
    open,
    close,
    successText,
    sign,
    unsuccess,
    closeAsan,
    path,
    closeWithoutRedirect,
    templates,
    closeParentModal,
  } = props;
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: paperProps,
      }}
      onClose={() => {
        close(false);
        closeParentModal(false);
        if (closeAsan !== undefined) {
          closeAsan(false);
        }
      }}
    >
      <DialogContent sx={dialogContent}>
        {!unsuccess ? (
          <SuccessIcon sx={{ width: '64px', height: '64px' }} />
        ) : (
          <ErrorIcon sx={{ width: '64px', height: '64px' }} />
        )}

        {/*<Button*/}
        {/*  color={'tertiary'}*/}
        {/*  onClick={() => {*/}
        {/*    close(false);*/}
        {/*  }}*/}
        {/*  sx={closeBtn}*/}
        {/*>*/}
        {/*  <CloseIcon />*/}
        {/*</Button>*/}
        <Typography sx={{ fontSize: '26px', fontWeight: 600, textAlign: 'center' }}>{successText}</Typography>
        {sign ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
            <Button
              color={'primary'}
              onClick={() => {
                window.location.href = `${lang}/home-page`;
                close(false);
                if (closeAsan !== undefined) {
                  closeAsan(false);
                }
              }}
            >
              Ana səhifəyə keçid et
            </Button>
            <Button
              onClick={() => {
                if (path !== undefined) {
                  window.location.href = `${lang}/templates-page`;
                } else {
                  window.location.href = `${lang}/transfer-page`;
                }
                close(false);
              }}
              color={'secondary'}
            >
              Bağla
            </Button>
          </Box>
        ) : templates ? (
          <Box sx={{ display: 'flex', gap: '12px' }}>
            <Button
              color={'primary'}
              onClick={() => {
                window.location.href = `${lang}/templates-page`;
                close(false);
              }}
            >
              Şablonlara keçid et
            </Button>
            <Button
              onClick={() => {
                close(false);
                if (closeParentModal) {
                  closeParentModal(false);
                }
              }}
              color={'secondary'}
            >
              Bağla
            </Button>
          </Box>
        ) : (
          <Button
            sx={{ width: '100%' }}
            onClick={() => {
              if (closeWithoutRedirect) {
                close(false);

                return;
              }
              if (path !== undefined) {
                window.location.href = `${lang}/templates-page`;
              } else {
                window.location.href = `${lang}/transfer-page`;
              }
              close(false);
              closeParentModal(false);
            }}
            color={'secondary'}
          >
            Bağla
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
